module.exports = __webpack_public_path__ + "img/search.1c96abec.svg";